module.exports = __webpack_public_path__ + "static/img/hotelDf.b9ab16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotelDf.png
// module id = rLx6
// module chunks = 1